import React, { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';

const PremiumContext = createContext();

export const usePremium = () => {
  const context = useContext(PremiumContext);
  if (!context) {
    throw new Error('usePremium must be used within PremiumProvider');
  }
  return context;
};

// Features نیازمند Premium
const PREMIUM_FEATURES = {
  test_romantic: {
    title: 'تست همسر/نامزد',
    description: 'ببین عشق زندگیت چقدر تو رو میشناسه',
    benefits: ['سوالات اختصاصی عاشقانه', 'تحلیل رابطه', 'نتایج خصوصی']
  },
  test_crush: {
    emoji: '💘',
    title: 'تست کراش',
    description: 'ببین علاقه‌مندیت چقدرت میشناسه',
    benefits: ['سوالات ویژه', 'تست هیجان‌انگیز', 'نتایج جذاب']
  },
  test_classmate: {
    emoji: '📚',
    title: 'تست هم‌کلاسی',
    description: 'هم‌کلاسیات چقدر میشناسنت؟',
    benefits: ['سوالات دانشجویی', 'سوالات درسی', 'خاطرات کلاس']
  },
  test_follower: {
    emoji: '📱',
    title: 'تست فالوور',
    description: 'فالوورات چقدر میشناسنت؟',
    benefits: ['سوالات اجتماعی', 'درباره اینستاگرام', 'شبکه‌های اجتماعی']
  },
  test_deep: {
    title: 'تست عمیق (30 سوال)',
    description: 'شناخت دقیق‌تر با 30 سوال',
    benefits: ['20 سوال بیشتر', 'تحلیل کامل‌تر', 'نتایج دقیق‌تر']
  },
  advanced_analytics: {
    title: 'آمار پیشرفته',
    description: 'تحلیل کامل نتایج',
    benefits: ['نمودارها و چارت‌ها', 'مقایسه با دیگران', 'دانلود گزارش PDF']
  }
};

export const PremiumProvider = ({ children }) => {
  const { user } = useAuth();
  const [premiumData, setPremiumData] = useState(null);
  const isPremium = user?.is_premium === 1 && 
                    user?.premium_expires_at && 
                    new Date(user.premium_expires_at) > new Date();


  const checkPremiumAccess = (feature) => {
    return isPremium;
  };

  const getFeatureInfo = (feature) => {
    return PREMIUM_FEATURES[feature] || null;
  };

  const value = {
    isPremium,
    checkPremiumAccess,
    getFeatureInfo,
    premiumFeatures: PREMIUM_FEATURES
  };

  return (
    <PremiumContext.Provider value={value}>
      {children}
    </PremiumContext.Provider>
  );
};